<template>
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.6"
      d="M103 105V42.4242V36.5909L99.2824 35L24 42.4242V105H103Z"
      :fill="cssVars.colorLine100"
    />
    <path
      d="M98.9999 35H37.9999C35.7908 35 33.9999 36.7909 33.9999 39V91C33.9999 93.2091 35.7908 95 37.9999 95H98.9999C101.209 95 103 93.2091 103 91V39C103 36.7909 101.209 35 98.9999 35Z"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M98.8254 35.5C98.8254 35.5 107.09 62.3063 82.7862 75.5L72 68.7286L79.4943 35.5698L98.8254 35.5Z"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M85.8007 72.0325L104.77 88.8141C106.743 90.5753 106.954 93.6047 105.193 95.5772C103.432 97.5498 100.473 97.6907 98.5001 95.9999L79.108 78.866"
      :fill="cssVars.colorSurface400"
    />
    <path
      d="M85.8007 72.0325L104.77 88.8141C106.743 90.5753 106.954 93.6047 105.193 95.5772C103.432 97.5498 100.473 97.6907 98.5001 95.9999L79.108 78.866"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M82.2073 61H24.8507C20.5153 61 17.0001 56.7463 17.0001 51.5C17.0001 46.2537 20.5153 42 24.8507 42H82.1487C86.4842 42 89.9994 46.2537 89.9994 51.5C90.058 56.7463 86.5427 61 82.2073 61Z"
      :fill="cssVars.colorSurface400"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M59.2687 86.2985C78.747 86.2985 94.5373 70.6856 94.5373 51.4261C94.5373 32.1666 78.747 16.5537 59.2687 16.5537C39.7903 16.5537 24 32.1666 24 51.4261C24 70.6856 39.7903 86.2985 59.2687 86.2985Z"
      :fill="cssVars.colorSurface400"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M87.9999 51.5C87.9999 55.2125 86.6986 58.5875 84.51 61.0175C82.3806 63.4475 79.4231 65 76.1699 65H36.4209C36.1251 64.19 35.8294 63.38 35.5928 62.5025C33.1084 54.1325 33.6408 45.4925 36.4209 38H76.1699C82.7355 38 87.9999 44.075 87.9999 51.5Z"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M103.033 18.313C103.526 19.2992 103.174 20.4969 102.188 20.99L97.4675 23.3853C96.4812 23.8784 95.2836 23.5262 94.7905 22.5399C94.2973 21.5536 94.6496 20.356 95.6358 19.8628L100.356 17.4676C101.342 16.9744 102.54 17.3971 103.033 18.313Z"
      :stroke="cssVars.colorGray4"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M93.0998 10L90 15.6359"
      :stroke="cssVars.colorGray4"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M80.3806 45.7021L71.2222 55.565"
      :stroke="cssVars.colorSurface400"
      stroke-width="1.74362"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M71.2222 45.7021L80.3806 55.565"
      :stroke="cssVars.colorSurface400"
      stroke-width="1.74362"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'

let id = 15
export default defineComponent({
  name: 'SearchEmpty',
  setup() {
    const ns = useNamespace('empty')

    const cssVars = {
      colorLine100: `var(${ns.cssVarName('color-line-100')})`,
      colorGray4: `var(${ns.cssVarName('color-gray-4')})`,
      colorGray6: `var(${ns.cssVarName('color-gray-6')})`,
      colorSurface400: `var(${ns.cssVarName('color-surface-400')})`,
    }

    return {
      ns,
      id: ++id,
      cssVars,
    }
  },
})
</script>
